import { memo } from 'react';
import { useNavigate } from 'react-router';
import reportingLogo from '@assets/images/reporting-logo.svg';
import { NavigateRoutesEnum } from '@features/routing/routesEnum';



interface TitleProps {
	successInit: boolean,
	searchIsOpen: boolean,
}


const Title = (props: TitleProps) => {
	const { successInit, searchIsOpen } = props;

	const navigate = useNavigate();

	return (
		<div className='toolbar-title'>
			
			<div className='title-logo'>
				<img
					src={reportingLogo}
					alt="brand-logo"
					onClick={(() => navigate(NavigateRoutesEnum.basePath))} />
			</div>

			<p className={`title-name${searchIsOpen ? ' hidden' : ''}`}>CT</p>

			{successInit &&
				<p className={`section-name${searchIsOpen ? ' hidden' : ''}`}>Moji zákazníci</p>}

		</div>
	);
}

export default memo(Title);